module.exports = __webpack_public_path__ + "static/media/boon_network.872fcb13.png";